import { useQuery } from '@tanstack/react-query';
import { buildTradableTokens, getPriceServiceRest } from '@/lib/prices';

const TOKEN_LIST_TTL_MS = 30 * 60 * 1000;

/**
 * Every token with a perpetual on one of our futures exchanges, from the
 * price service. Loaded once and cached; the picker filters on the device.
 */
export const useTradableTokens = (enabled = true) =>
  useQuery({
    queryKey: ['prices', 'tradable-tokens'],
    queryFn: async () => buildTradableTokens(await getPriceServiceRest().getTokenList()),
    enabled,
    staleTime: TOKEN_LIST_TTL_MS,
    gcTime: TOKEN_LIST_TTL_MS * 2,
    refetchOnWindowFocus: false,
  });
